import React, { useState, useEffect, useRef } from 'react';
import './ContactUs.css';
import { Box, Typography, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import ContactUsDeskImg from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/ContactUsDesk.png';
import ContactUsMobileImg from 'D:/DentalClinicApplication/aarogyamdental/src/components/Pictures/ContactUsMobile.png';
import Footer from './Footer';
import axios from 'axios';
import emailjs from '@emailjs/browser';


// Dummy DatePick component (You can replace this with your actual Date Picker component)
const DatePick = () => (
  <input type="date" className="form-control form-control-lg" style={{ marginTop: 10, marginBottom: 10 }} />
);

const BannerMobile = styled(Box)({
  position: 'relative',
  height: '200px',
  backgroundImage: `url(${ContactUsMobileImg})`, // Replace with your image path
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  opacity: 0.7,
  width: '100%',
});

const BannerDesktop = styled(Box)({
  position: 'relative',
  height: '150px',
  backgroundImage: `url(${ContactUsDeskImg})`, // Replace with your image path
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'white',
  opacity: 0.7,
  width: '100%',
});


const ContactUs = () => {

  const [isMobile, setIsMobile] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [message, setMessage] = useState("");
  const [alreadyVisited, setAlreadyVisited] = useState(false);
  const [appointmentmessage, setAppointmentMessage] = useState('');

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_xqanb2f', 'template_6jz5hy6', form.current, {
        publicKey: 'ky8BV5Qi_GPMIipf9',
      })
      .then(
        () => {
          console.log('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
      setAppointmentMessage('The appointment is confirmed! You will get a call back soon!');
  };


  const handleSubmit = async(e) => {
    e.preventDefault();

    // Prepare the form data to be sent
    const formData = {
      firstName,
      lastName,
      email,
      mobileNumber,
      message,
      alreadyVisited,
    };

    // For demonstration, just log the data
    console.log("Form Data: ", formData);

  };


  const checkDeviceType = () => {
    if (window.innerWidth <= 768) {
      setIsMobile(true); // Mobile
    } else {
      setIsMobile(false); // Desktop
    }
  };
  const isSubmitDisabled = !firstName || !mobileNumber;


  // Set up the resize event listener when the component mounts
  useEffect(() => {
    checkDeviceType(); // Check initial screen size
    window.addEventListener('resize', checkDeviceType); // Add resize event listener

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', checkDeviceType);
    };
  }, []);


  // Handle input change
  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };


  return (
    <div >
      {isMobile ? (
        <BannerMobile />
      ) : (
        <BannerDesktop />
      )}
      <div className="contact-us-container">

        <div className="contact-us-details">
          {/* Visit Us Section */}
          <div className="contact-us-section">
            <h2>Visit Us</h2>
            <p> First floor Plot, No: 320, Rd No 7, Kakatiya Hills, Guttala_Begumpet, Kavuri Hills, Madhapur, Hyderabad, Telangana 500081</p>
          </div>

          {/* Call Us Section */}
          <div className="contact-us-section">
            <h2>Call Us</h2>
            <p><a href="tel:+919032821700">+919032821700</a></p>
          </div>

          {/* Email Us Section */}
          <div className="contact-us-section">
            <h2>Email Us</h2>
            <p><a href="mailto:aarogyamdental.adc@gmail.com">aarogyamdental.adc@gmail.com</a></p>
          </div>

          {/* Clinic Hours Section */}
          <div className="contact-us-section">
            <h2>Clinic Hours</h2>
            <p>Mon - Sat: 11:00 AM - 8:00 PM</p>
            <p>Sun: 11:00 AM - 3:00 PM</p>
          </div>
        </div>

        {/*<form ref={form} onSubmit={sendEmail}>
        <label>Name</label>
        <input type="text" name="from_name" />
        <label>Email</label>
        <input type="email" name="from_email" />
        <label>Message</label>
        <textarea name="message" />
        <input type="submit" value="Send" />
      </form>*/}
        {/* Appointment Form (Card Style) */}
        <div id="specific-section" className="appointment-form-card">
          <h2 className="appointment-form-header">Appointment Form</h2>
          <form  className="form-container" ref={form} onSubmit={sendEmail}>
            <div className="input-group">
              <input
                type="text"
                className="form-control form-control-lg"
                placeholder="First Name (Required)"
                name="from_fname"
                style={{ width: "100%" }}
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
              />
              <input
                type="text"
                className="form-control form-control-lg"
                placeholder="Last Name"
                name="from_lname"
                style={{ width: "100%" }}
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
            <input
              className="form-control form-control-lg"
              type="email"
              placeholder="Email"
              name="from_email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              className="form-control form-control-lg"
              type="number"
              placeholder="Mobile Number (Required)"
              name="from_mobile"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value)}
              required
            />
            <textarea
              id="message"
              name="message"
              rows="5"
              className="form-control form-control-lg"
              placeholder="Type your message here..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="AlreadyVisited"
                name ="alreadyvisited"
                checked={alreadyVisited}
                onChange={(e) => setAlreadyVisited(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="AlreadyVisited">
                Already Visited
              </label>
            </div>
            <DatePick />
            <button type="submit" className="btn btn-warning submit-btn" value="Send"  disabled={isSubmitDisabled}>
              Submit
            </button>
          </form>
          {appointmentmessage && <p style={{color:'yellow'}}>{appointmentmessage}</p>}
        </div>

        {/* Google Map Section */}
        <div className="google-map" style={{ marginTop: 50 }}>
          <h2>Find Us On Google Maps</h2>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5022.383996705362!2d78.39983481096114!3d17.447490707749935!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb91006d187577%3A0x517c68839ef43f42!2sAarogyam%20Dental%20Care!5e0!3m2!1sen!2sin!4v1737829680594!5m2!1sen!2sin"
            width="100%"
            height="300"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactUs;
